import { render, staticRenderFns } from "./RoomProviderItem.vue?vue&type=template&id=2fe9148a&scoped=true&"
import script from "./RoomProviderItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoomProviderItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RoomProviderItem.vue?vue&type=style&index=0&id=2fe9148a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9148a",
  null
  
)

export default component.exports